<template>
  <div class="sip_status_time_w">
    <!-- <div v-if="!$isMob" class="sip_status_time_label">время</div> -->
    <div class="sip_status_time">
      {{timer}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'Timer',
  props: ['timer'],
}
</script>

<style lang="stylus">
.sip_status_time_w
  .sip_status_time
    @media screen and (max-width: 900px)
      font-size 34px
      line-height 1
      text-shadow none
      background rgba(0, 0, 0, 0)
      padding 0

  @media screen and (max-width: 900px)
    font-family 'Cute Font'
    font-style normal
    font-weight normal
    font-size 35px
    line-height 44px
    color #AAFF58
    text-shadow 0px 2.19608px 2.19608px rgba(0, 0, 0, 0.25)

    // background #3E6470
    // border 1px solid #FFFFFF
    // box-sizing border-box
    // box-shadow inset 0px 4px 0px rgba(0, 0, 0, 0.25)
    // border-radius 6px
    // display flex
    // justify-content space-between
    // font-family Roboto
    // font-size 10px
    // line-height 100%
    // color #FFF
    // padding 0px 7px
    // .sip_status_time_label
    //   margin-top 16px

</style>